<template>
  <div class="topic_warp">
    <div class="big"
         v-if=" question.question_code_head == '' && Number(question.question_score) == 0">
      <div class="top">
        <div class="head content">
          <div class="tip">
            <!-- {{question.question_category_name}}: -->
            ( 题目ID：{{question.question_id}}，{{question.question_type_name||question.question_category_name}}：{{question.question_big_score}}分,{{question.source_name}})
          </div>

        </div>

        <div class="topic_content content">
          <div v-html="question.question_content"></div>
        </div>
      </div>

      <div class="bottom">
        <div class="topic"
             v-for="(item,index) in question.question_children"
             :style="{'margin-top':index==0?'':'20px'}"
             :key="index">
          <p class="title">
            <!-- {{item.question_category_name}}: -->
            <span class="tip">
              <div>题目{{item.answer_id}}
                ( 题目ID：{{item.question_id}}, {{item.question_type_name}}：{{item.question_score}}分，{{item.source_name}})</div>

            </span>

          </p>
          <div class="content">
            <div v-html="item.question_content"></div>
          </div>
          <div class="selects_warp">
            <Select ref="SelectRef"
                    :answer.sync="item.answer"
                    :questionId="item.question_id"
                    @setAnwer="setAnwer"
                    :type="item.topic + ''" />
          </div>
        </div>
      </div>
    </div>
    <div class="small"
         v-else>

      <div class=" tip">
        <div> 题目{{question.answer_id}}
          ( 题目ID：{{question.question_id}}，{{question.question_type_name}},{{question.question_category_name}}:{{question.question_score}}分，{{question.source_name}})</div>
        <span class="topic_id">
        </span>
      </div>

      <!-- ID：{{$rands(question.question_id)}} -->

      <div class="content">
        <div v-html="question.question_content"></div>
      </div>
      <div class="selects_warp">
        <Select ref="SelectRef"
                :answer.sync="question.answer"
                :questionId="question.question_id"
                @setAnwer="setAnwer"
                :type="question.topic + ''" />
      </div>
    </div>
  </div>
</template>

<script>
import Select from './select.vue'
export default {
  data () {
    return {
      paperIndex: 0,
    }
  },
  props: {
    question: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    Select
  },
  mounted () {
    this.$nextTick(() => {
      let topicContentTd = document.getElementsByTagName('td')
      if (topicContentTd && topicContentTd.length) {
        for (let i = 0; i < topicContentTd.length; i++) {
          if (topicContentTd[i].width) {
            topicContentTd[i].width = topicContentTd[i].width * 18 / 16
          }
        }
      }
    })
  },
  methods: {
    setAnwer (id, answer) {
      this.$emit('setAnwer', id, answer)
    },
  }
}
</script>

<style lang="scss" scoped>
.topic_warp {
  ::v-deep img {
    vertical-align: middle;
  }
  .tip {
    padding: 0 0 12px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }
  .content {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }
  .big {
    background: #f5f5f5;

    .top,
    .topic {
      padding: 12px 16px;
      margin-bottom: 12px;
      background: #fff;
    }
  }
  .small {
    padding: 12px 16px;
    background: #fff;
  }
}
</style>